import styled from 'styled-components';

export const Wrapper = styled.div`
    height: ${({ theme }) => theme.height};
    width: 100%;
    background:  ${({ theme }) => theme.backgroundColor};
    border-top:  1px solid ${({ theme }) => theme.borderColor};
    padding ${({ theme }) => theme.padding};
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
`;

export const IconWrapper = styled.a`
  cursor: pointer;
  padding: 5px;
`;
